import(/* webpackMode: "eager" */ "/vercel/path0/src/app/masjid/claim/page.tsx");
